// styles
import "./Homepage.css"

// components

export default function Home() {
  return (
    <div className="page-placeholder">
      <h2>Coming Soon 建設中</h2>
      <p>Please look forward to a new page here in November!</p>
    </div>
  )
}
